import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    bank,
    taxId,
    totalTax,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [firstTime.name]: Yup.number().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.number().notRequired(supplementaryForThe.errorMsg),
  [bank.name]: Yup.string().notRequired(bank.errorMsg),
  [totalTax.name]: Yup.number().notRequired(totalTax.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
